// TODO - ORD-1259 remove useMenuListItem hook when useBasket is rolled out to MenuListItems component
import { useMemo } from 'react';

import { Currency } from '../../../../../../../core/api/general/general.types';
import { MenuItem } from '../../../../../../../core/api/menu/menu.types';
import { formatNumberToCurrency } from '../../../../../../../utils/basketUtils';
import {
  handleAddItem,
  handleRemoveItem,
} from '../../../../../../../utils/menuUtils';
import {
  BasketItems,
  OnAddItem,
  OnClickItem,
  OnRemoveItem,
} from '../../../../types';

interface UseMenuListItem {
  basketQuantity: number;
  localisedPrice: string;
  onHandleAddItem: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => void;
  onHandleRemoveItem: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => void;
}

export const useMenuListItem = (
  basketItems: BasketItems,
  currency: Currency,
  languageCode: string,
  menuItem: MenuItem,
  onAddItem: OnAddItem,
  onClickItem?: OnClickItem,
  onRemoveItem?: OnRemoveItem,
): UseMenuListItem => {
  const basketQuantity = useMemo(
    () =>
      basketItems.filter(
        (basketItem) => basketItem.Item.MenuItemId === menuItem.MenuItemId,
      ).length || 0,
    [basketItems.length, menuItem.MenuItemId],
  );

  const localisedPrice = useMemo(
    () => formatNumberToCurrency(menuItem.ActualPrice, currency, languageCode),
    [menuItem.ActualPrice, currency, languageCode],
  );

  const onHandleAddItem = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ): void => {
    if (onClickItem) {
      event.stopPropagation();
    }

    handleAddItem(
      onAddItem,
      basketItems,
      menuItem,
      basketQuantity,
      onClickItem,
    );
  };

  const onHandleRemoveItem = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ): void => {
    if (onClickItem) {
      event.stopPropagation();
    }

    handleRemoveItem(basketItems, menuItem, onRemoveItem);
  };

  return {
    basketQuantity,
    localisedPrice,
    onHandleAddItem,
    onHandleRemoveItem,
  };
};
